import { nextTick, ref } from 'vue'
import { useQuestionnaireStore } from '@/questionnaire/stores/questionnaire'
import { useLegalDocumentStore } from '@/questionnaire/stores/legalDocument'
import type { LegalDocumentSection, TemplateVariableValue } from '@/questionnaire/types'
import { updateDocument } from '@/services/documentsService'
import { errorNotification, successNotification } from '@/utils/notifications'
import { getTemplateVariablesArray } from '@/utils/apiFormatters'

export default (section: LegalDocumentSection) => {
  const isOpen = ref(false)
  const questionnaireStore = useQuestionnaireStore()
  const legalDocumentStore = useLegalDocumentStore()

  const isEditable = !!section?.template_variables?.length
  const handleSubmit = async (data: Record<string, TemplateVariableValue>) => {
    let optional_sections = [...(questionnaireStore.document.optional_sections as unknown as Array<string>)]
    optional_sections.push(section.code)
    optional_sections = [...new Set(optional_sections)]

    questionnaireStore.templateVariableValues = { ...questionnaireStore.templateVariableValues, ...data }

    if (section.optional) {
      questionnaireStore.templateVariableValues[`section___${section.code}`] = true
      section.optional_but_selected = true
    }

    const updateDocumentView = () => {
      legalDocumentStore.insert(section.code)
      nextTick(() => {
        const sectionElement = document.getElementById(`clause-${section.code}`)
        if (sectionElement) {
          sectionElement.scrollIntoView({ behavior: 'smooth' })
        }
      })
    }

    await updateDocumentValues(data, optional_sections)
      .then(success => {
        if (success) {
          updateDocumentView()
          close()
        }
      })
      .catch(error => {
        errorNotification(error?.response?.data?.error)
      })
  }
  const addClause = () => {
    if (isEditable) {
      open()
    } else {
      handleSubmit({})
    }
  }

  async function updateDocumentValues(
    templateVariableValues: Record<string, TemplateVariableValue>,
    sections: Array<string>
  ): Promise<boolean> {
    const variableValues = getTemplateVariablesArray(templateVariableValues)
    const data = { optional_sections: sections }
    const documentId = questionnaireStore.document.id as unknown as string
    return await updateDocument(documentId, variableValues, data)
      .then(async resp => {
        if (resp?.optional_sections) {
          questionnaireStore.document.optional_sections = resp.optional_sections
        }

        successNotification()
        return true
      })
      .catch(error => {
        errorNotification(error.response.data.error)
        return false
      })
  }

  const close = () => (isOpen.value = false)
  const open = () => (isOpen.value = true)

  return {
    close,
    open,
    addClause,
    handleSubmit,
    isEditable,
    isOpen,
  }
}
